import React from 'react';

export const GoldCupIcon = () => (
  <svg width="96" height="96" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M48.0986 89.4401C63.6498 89.4401 76.2566 89.0841 76.2566 88.645C76.2566 88.2059 63.6498 87.85 48.0986 87.85C32.5473 87.85 19.9405 88.2059 19.9405 88.645C19.9405 89.0841 32.5473 89.4401 48.0986 89.4401Z"
      fill="#D8DFEA"
    />
    <path
      d="M84.8 14.7423V22.47C84.8 35.0205 74.6277 45.1983 62.084 45.1983H58.9037L62.4337 41.5572C72.7968 41.3708 81.1654 32.8796 81.1654 22.47V16.5607H67.5358L67.9902 12.9242H82.9829C83.9867 12.9239 84.8 13.7376 84.8 14.7423Z"
      fill="#E8A615"
    />
    <path
      d="M59.8123 67.0944V71.1082H36.1877V67.0944C36.1877 66.7672 36.3648 66.4626 36.651 66.3035L38.4411 65.2944C41.5395 63.549 43.4568 60.2715 43.4568 56.7122V52.4711H52.5432V56.7122C52.5432 60.2714 54.4605 63.5488 57.5589 65.2944L59.349 66.3035C59.6352 66.4626 59.8123 66.7672 59.8123 67.0944Z"
      fill="#E8A615"
    />
    <path
      d="M59.8123 67.0944V71.1082H57.5408V67.0944C57.5408 66.7672 57.3637 66.4626 57.0775 66.3035L55.2874 65.2944C52.189 63.549 50.2717 60.2715 50.2717 56.7122V52.4711H52.5434V56.7122C52.5434 60.2714 54.4607 63.5488 57.5591 65.2944L59.3491 66.3035C59.6352 66.4626 59.8123 66.7672 59.8123 67.0944Z"
      fill="#B7791D"
    />
    <path
      d="M55.2691 48.9254V51.5619C55.2691 52.8165 54.2515 53.8347 52.9974 53.8347H43.0024C41.7485 53.8347 40.7307 52.8165 40.7307 51.5619V48.9254H55.2691Z"
      fill="#E8A615"
    />
    <path d="M52.5432 53.8348H43.4568V55.1713H52.5432V53.8348Z" fill="#B7791D" />
    <path
      d="M63.4469 70.1992V86.1089H32.5531V70.1992C32.5531 69.6992 32.9621 69.29 33.4618 69.29H62.5383C63.0381 69.29 63.4469 69.6992 63.4469 70.1992Z"
      fill="#343B49"
    />
    <path
      d="M63.4469 70.1992V86.1089H61.6296V70.1992C61.6296 69.6992 61.2206 69.29 60.721 69.29H62.5382C63.0381 69.29 63.4469 69.6992 63.4469 70.1992Z"
      fill="#262D38"
    />
    <path
      d="M66.1728 85.6544V87.4726C66.1728 87.9726 65.7638 88.3817 65.2642 88.3817H30.7358C30.2362 88.3817 29.8272 87.9726 29.8272 87.4726V85.6544C29.8272 85.1544 30.2362 84.7452 30.7358 84.7452H65.2642C65.764 84.7452 66.1728 85.1544 66.1728 85.6544Z"
      fill="#262D38"
    />
    <path
      d="M66.1728 85.6544V87.4726C66.1728 87.9726 65.7638 88.3817 65.2641 88.3817H63.4469C63.9465 88.3817 64.3555 87.9726 64.3555 87.4726V85.6544C64.3555 85.1544 63.9465 84.7452 63.4469 84.7452H65.2641C65.764 84.7452 66.1728 85.1544 66.1728 85.6544Z"
      fill="#171C23"
    />
    <path
      d="M58.9037 73.8356V80.1995C58.9037 80.6995 58.4947 81.1086 57.9951 81.1086H38.005C37.5053 81.1086 37.0963 80.6995 37.0963 80.1995V73.8356C37.0963 73.3356 37.5053 72.9265 38.005 72.9265H57.9951C58.4949 72.9265 58.9037 73.3356 58.9037 73.8356Z"
      fill="#E8A615"
    />
    <path
      d="M55.2691 48.9254V51.5619C55.2691 52.8165 54.2515 53.8347 52.9975 53.8347H51.1802C52.4341 53.8347 53.4519 52.8165 53.4519 51.5619V48.9254H55.2691Z"
      fill="#B7791D"
    />
    <path
      d="M38.4592 45.198H33.916C21.3723 45.198 11.2 35.0203 11.2 22.4697V14.7422C11.2 13.7376 12.0133 12.924 13.0173 12.924H28.0099V16.5604H14.8346V22.4697C14.8346 32.8793 23.2032 41.3705 33.5662 41.5569L38.4592 45.198Z"
      fill="#E8A615"
    />
    <path
      d="M70.2618 9.28735V11.1056C70.2618 33.1974 60.2939 51.1073 48 51.1073C35.7061 51.1073 25.7382 33.1976 25.7382 11.1056V9.28735H70.2618Z"
      fill="#E8A615"
    />
    <path
      d="M25.9427 16.5604H24.1254C24.0346 15.3649 23.9755 14.1513 23.9437 12.924H25.761C25.7928 14.1512 25.8518 15.3649 25.9427 16.5604Z"
      fill="#B7791D"
    />
    <path
      d="M36.3512 45.198H34.5339C33.5208 44.0798 32.5576 42.8161 31.6626 41.425C32.2896 41.5023 32.921 41.5433 33.5662 41.5569C34.4386 42.8978 35.3699 44.1161 36.3512 45.198Z"
      fill="#B7791D"
    />
    <path
      d="M55.2691 48.9254V49.8345C52.9885 51.2483 50.5441 52.0165 48 52.0165C45.4558 52.0165 43.0115 51.2483 40.7309 49.8345V48.9254C43.0115 50.3392 45.4558 51.1073 48 51.1073C50.5441 51.1073 52.9885 50.3392 55.2691 48.9254Z"
      fill="#B7791D"
    />
    <path
      d="M70.2617 9.28735V11.1056C70.2617 32.5065 60.9072 49.9846 49.145 51.0574C60.5757 49.971 64.8099 32.4976 64.8099 11.1056V9.28735H70.2617Z"
      fill="#B7791D"
    />
    <path
      d="M72.5333 8.83286C72.5333 9.46022 72.2789 10.0284 71.8699 10.442C71.4565 10.8511 70.8886 11.1057 70.2616 11.1057H25.7382C24.4843 11.1057 23.4666 10.0874 23.4666 8.83286C23.4666 8.2055 23.721 7.63734 24.1299 7.22374C24.5434 6.81462 25.1112 6.56006 25.7382 6.56006H70.2618C71.5157 6.56006 72.5333 7.5783 72.5333 8.83286Z"
      fill="#E8A615"
    />
    <path
      d="M70.2618 11.1056C70.2618 11.7147 70.2527 12.3194 70.2391 12.9238H25.761C25.7474 12.3192 25.7382 11.7147 25.7382 11.1056H70.2618Z"
      fill="#B7791D"
    />
    <path
      d="M72.5333 8.83286C72.5333 9.46022 72.2789 10.0284 71.8699 10.442C71.4565 10.8511 70.8886 11.1057 70.2616 11.1057H65.264C65.891 11.1057 66.4589 10.8511 66.8723 10.442C67.2813 10.0284 67.5357 9.46006 67.5357 8.83286C67.5357 7.5783 66.5181 6.56006 65.264 6.56006H70.2616C71.5157 6.56006 72.5333 7.5783 72.5333 8.83286Z"
      fill="#B7791D"
    />
    <path
      d="M58.9037 73.8357V80.1995C58.9037 80.6995 58.4947 81.1086 57.995 81.1086H39.9586C43.6294 81.0358 55.7235 80.2541 55.7235 72.9264H57.9952C58.4949 72.9266 58.9037 73.3357 58.9037 73.8357Z"
      fill="#B7791D"
    />
    <path
      d="M38.005 77.9267V74.2075C38.005 74.0021 38.1714 73.8357 38.3766 73.8357H46.5235C46.5235 73.8357 40.0494 74.5176 38.005 77.9267Z"
      fill="#FFCC66"
    />
    <path
      d="M33.5754 74.2903V70.5711C33.5754 70.3656 33.7418 70.1992 33.947 70.1992H42.0939C42.0939 70.1992 35.6197 70.881 33.5754 74.2903Z"
      fill="#4E5868"
    />
    <path
      d="M48 49.7437C43.0661 49.7437 29.3819 39.3296 27.7237 14.7421H33.121C34.4794 44.8253 48 49.7437 48 49.7437Z"
      fill="#FFCC66"
    />
    <path d="M38.4592 67.4718C38.4592 67.4718 44.8197 63.3808 44.8197 57.4713V67.4718H38.4592Z" fill="#FFCC66" />
    <path d="M26.6469 7.46912V8.8328H24.3752C24.3752 8.08272 24.984 7.46912 25.7382 7.46912H26.6469Z" fill="#FFCC66" />
    <path
      d="M71.6019 12.9238C71.5701 14.1512 71.5111 15.3648 71.4157 16.5603H67.5359L67.9903 12.9238H71.6019Z"
      fill="#B7791D"
    />
    <path
      d="M63.8512 41.4797C62.9608 42.8479 62.0112 44.0935 61.0117 45.1981H58.9037L60.512 43.5436L62.4337 41.5572C62.9109 41.5479 63.3834 41.5207 63.8512 41.4797Z"
      fill="#B7791D"
    />
  </svg>
);

export const SilverCupIcon = () => (
  <svg width="96" height="96" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M48.0986 89.4399C63.6498 89.4399 76.2566 89.084 76.2566 88.6449C76.2566 88.2058 63.6498 87.8499 48.0986 87.8499C32.5473 87.8499 19.9405 88.2058 19.9405 88.6449C19.9405 89.084 32.5473 89.4399 48.0986 89.4399Z"
      fill="#D8DFEA"
    />
    <path
      d="M84.8 14.7422C84.8 17.3181 84.8 19.894 84.8 22.4699C84.8 35.0205 74.6276 45.1983 62.084 45.1983C61.0239 45.1983 59.9638 45.1983 58.9036 45.1983C60.0803 43.9846 61.257 42.7708 62.4337 41.5571C72.7968 41.3707 81.1654 32.8795 81.1654 22.4699C81.1654 20.5001 81.1654 18.5304 81.1654 16.5607C76.6222 16.5607 72.079 16.5607 67.5358 16.5607C67.6873 15.3485 67.8387 14.1364 67.9902 12.9242C72.9878 12.9242 77.9853 12.9242 82.9829 12.9242C83.9867 12.9239 84.8 13.7376 84.8 14.7422Z"
      fill="#C0C0C0"
    />
    <path
      d="M59.8123 67.0944C59.8123 68.4323 59.8123 69.7703 59.8123 71.1082C51.9375 71.1082 44.0625 71.1082 36.1876 71.1082C36.1876 69.7703 36.1876 68.4323 36.1876 67.0944C36.1876 66.7672 36.3648 66.4625 36.651 66.3035C37.2477 65.9671 37.8444 65.6308 38.4411 65.2944C41.5395 63.549 43.4568 60.2715 43.4568 56.7122C43.4568 55.2985 43.4568 53.8848 43.4568 52.4711C46.4856 52.4711 49.5144 52.4711 52.5432 52.4711C52.5432 53.8848 52.5432 55.2985 52.5432 56.7122C52.5432 60.2714 54.4605 63.5488 57.5589 65.2944C58.1556 65.6308 58.7523 65.9671 59.349 66.3035C59.6352 66.4625 59.8123 66.7672 59.8123 67.0944Z"
      fill="#C0C0C0"
    />
    <path
      d="M59.8124 67.0944C59.8124 68.4323 59.8124 69.7703 59.8124 71.1082C59.0552 71.1082 58.298 71.1082 57.5408 71.1082C57.5408 69.7703 57.5408 68.4323 57.5408 67.0944C57.5408 66.7672 57.3637 66.4625 57.0774 66.3035C56.4807 65.9671 55.8841 65.6308 55.2874 65.2944C52.189 63.549 50.2717 60.2715 50.2717 56.7122C50.2717 55.2985 50.2717 53.8848 50.2717 52.4711C51.029 52.4711 51.7861 52.4711 52.5434 52.4711C52.5434 53.8848 52.5434 55.2985 52.5434 56.7122C52.5434 60.2714 54.4607 63.5488 57.5591 65.2944C58.1558 65.6308 58.7525 65.9671 59.3492 66.3035C59.6352 66.4625 59.8124 66.7672 59.8124 67.0944Z"
      fill="#8A8A8A"
    />
    <path
      d="M55.2691 48.9254C55.2691 49.8042 55.2691 50.6831 55.2691 51.5619C55.2691 52.8165 54.2515 53.8347 52.9974 53.8347C49.6657 53.8347 46.3341 53.8347 43.0024 53.8347C41.7485 53.8347 40.7307 52.8165 40.7307 51.5619C40.7307 50.6831 40.7307 49.8042 40.7307 48.9254C45.5768 48.9254 50.423 48.9254 55.2691 48.9254Z"
      fill="#C0C0C0"
    />
    <path d="M43.4568 53.8348H52.5432V55.1713H43.4568V53.8348Z" fill="#8A8A8A" />
    <path
      d="M63.4469 70.1992C63.4469 75.5024 63.4469 80.8057 63.4469 86.109C53.1489 86.109 42.851 86.109 32.5531 86.109C32.5531 80.8057 32.5531 75.5024 32.5531 70.1992C32.5531 69.6992 32.9621 69.29 33.4618 69.29C43.1539 69.29 52.8461 69.29 62.5383 69.29C63.0381 69.29 63.4469 69.6992 63.4469 70.1992Z"
      fill="#343B49"
    />
    <path
      d="M63.4469 70.1992C63.4469 75.5024 63.4469 80.8057 63.4469 86.109C62.8411 86.109 62.2354 86.109 61.6296 86.109C61.6296 80.8057 61.6296 75.5024 61.6296 70.1992C61.6296 69.6992 61.2206 69.29 60.7209 69.29C61.3267 69.29 61.9325 69.29 62.5383 69.29C63.0381 69.29 63.4469 69.6992 63.4469 70.1992Z"
      fill="#262D38"
    />
    <path
      d="M66.1728 85.6545C66.1728 86.2606 66.1728 86.8666 66.1728 87.4727C66.1728 87.9727 65.7638 88.3818 65.2641 88.3818C53.7547 88.3818 42.2453 88.3818 30.7359 88.3818C30.2362 88.3818 29.8272 87.9727 29.8272 87.4727C29.8272 86.8666 29.8272 86.2606 29.8272 85.6545C29.8272 85.1545 30.2362 84.7454 30.7359 84.7454C42.2453 84.7454 53.7547 84.7454 65.2641 84.7454C65.764 84.7454 66.1728 85.1545 66.1728 85.6545Z"
      fill="#262D38"
    />
    <path
      d="M66.1728 85.6545C66.1728 86.2606 66.1728 86.8666 66.1728 87.4727C66.1728 87.9727 65.7638 88.3818 65.2641 88.3818C64.6583 88.3818 64.0526 88.3818 63.4468 88.3818C63.9465 88.3818 64.3555 87.9727 64.3555 87.4727C64.3555 86.8666 64.3555 86.2606 64.3555 85.6545C64.3555 85.1545 63.9465 84.7454 63.4468 84.7454C64.0526 84.7454 64.6583 84.7454 65.2641 84.7454C65.7639 84.7454 66.1728 85.1545 66.1728 85.6545Z"
      fill="#171C23"
    />
    <path
      d="M58.9037 73.8357C58.9037 75.9569 58.9037 78.0782 58.9037 80.1995C58.9037 80.6995 58.4948 81.1086 57.9951 81.1086C51.3317 81.1086 44.6684 81.1086 38.005 81.1086C37.5053 81.1086 37.0963 80.6995 37.0963 80.1995C37.0963 78.0782 37.0963 75.9569 37.0963 73.8357C37.0963 73.3357 37.5053 72.9265 38.005 72.9265C44.6684 72.9265 51.3317 72.9265 57.9951 72.9265C58.4949 72.9265 58.9037 73.3357 58.9037 73.8357Z"
      fill="#C0C0C0"
    />
    <path
      d="M55.2692 48.9254C55.2692 49.8042 55.2692 50.6831 55.2692 51.5619C55.2692 52.8165 54.2515 53.8347 52.9974 53.8347C52.3917 53.8347 51.7859 53.8347 51.1802 53.8347C52.4341 53.8347 53.4519 52.8165 53.4519 51.5619C53.4519 50.6831 53.4519 49.8042 53.4519 48.9254C54.0577 48.9254 54.6634 48.9254 55.2692 48.9254Z"
      fill="#8A8A8A"
    />
    <path
      d="M38.4592 45.1981C36.9448 45.1981 35.4304 45.1981 33.916 45.1981C21.3723 45.1981 11.2 35.0203 11.2 22.4698C11.2 19.8939 11.2 17.3181 11.2 14.7423C11.2 13.7376 12.0133 12.9241 13.0173 12.9241C18.0148 12.9241 23.0124 12.9241 28.0099 12.9241C28.0099 14.1362 28.0099 15.3483 28.0099 16.5605C23.6181 16.5605 19.2263 16.5605 14.8345 16.5605C14.8345 18.5302 14.8345 20.5 14.8345 22.4698C14.8345 32.8794 23.2032 41.3706 33.5662 41.557C35.1972 42.7707 36.8282 43.9844 38.4592 45.1981Z"
      fill="#C0C0C0"
    />
    <path
      d="M70.2618 9.28735C70.2618 9.89343 70.2618 10.4995 70.2618 11.1056C70.2618 33.1974 60.2939 51.1073 48 51.1073C35.7061 51.1073 25.7383 33.1975 25.7383 11.1056C25.7383 10.4995 25.7383 9.89343 25.7383 9.28735C40.5794 9.28735 55.4206 9.28735 70.2618 9.28735Z"
      fill="#C0C0C0"
    />
    <path
      d="M25.9427 16.5605C25.337 16.5605 24.7312 16.5605 24.1254 16.5605C24.0346 15.365 23.9755 14.1514 23.9436 12.9241C24.5494 12.9241 25.1552 12.9241 25.7609 12.9241C25.7928 14.1513 25.8518 15.365 25.9427 16.5605Z"
      fill="#8A8A8A"
    />
    <path
      d="M36.3512 45.1981C35.7454 45.1981 35.1397 45.1981 34.5339 45.1981C33.5208 44.0799 32.5576 42.8162 31.6626 41.4252C32.2896 41.5025 32.921 41.5434 33.5662 41.557C34.4386 42.8979 35.3699 44.1162 36.3512 45.1981Z"
      fill="#8A8A8A"
    />
    <path
      d="M55.2691 48.9254C55.2691 49.2285 55.2691 49.5315 55.2691 49.8346C52.9885 51.2483 50.5441 52.0164 48 52.0164C45.4558 52.0164 43.0115 51.2483 40.7308 49.8346C40.7308 49.5315 40.7308 49.2285 40.7308 48.9254C43.0115 50.3392 45.4558 51.1074 48 51.1074C50.5441 51.1074 52.9885 50.3392 55.2691 48.9254Z"
      fill="#8A8A8A"
    />
    <path
      d="M70.2618 9.28735C70.2618 9.89343 70.2618 10.4995 70.2618 11.1056C70.2618 32.5065 60.9072 49.9846 49.145 51.0574C60.5757 49.971 64.8099 32.4975 64.8099 11.1056C64.8099 10.4995 64.8099 9.89343 64.8099 9.28735C66.6272 9.28735 68.4445 9.28735 70.2618 9.28735Z"
      fill="#8A8A8A"
    />
    <path
      d="M72.5333 8.83275C72.5333 9.46011 72.2789 10.0283 71.8699 10.4419C71.4565 10.851 70.8887 11.1056 70.2616 11.1056C55.4205 11.1056 40.5794 11.1056 25.7383 11.1056C24.4843 11.1056 23.4665 10.0873 23.4665 8.83275C23.4665 8.20539 23.7209 7.63721 24.1299 7.22361C24.5433 6.81449 25.1112 6.55994 25.7383 6.55994C40.5794 6.55994 55.4206 6.55994 70.2618 6.55994C71.5157 6.55994 72.5333 7.57819 72.5333 8.83275Z"
      fill="#C0C0C0"
    />
    <path
      d="M70.2618 11.1056C70.2618 11.7147 70.2527 12.3193 70.2391 12.9238C55.413 12.9238 40.587 12.9238 25.7609 12.9238C25.7473 12.3192 25.7383 11.7147 25.7383 11.1056C40.5794 11.1056 55.4206 11.1056 70.2618 11.1056Z"
      fill="#8A8A8A"
    />
    <path
      d="M72.5333 8.83275C72.5333 9.46011 72.2789 10.0283 71.8699 10.4419C71.4565 10.851 70.8887 11.1056 70.2616 11.1056C68.5958 11.1056 66.9298 11.1056 65.264 11.1056C65.891 11.1056 66.4589 10.851 66.8723 10.4419C67.2813 10.0283 67.5357 9.45995 67.5357 8.83275C67.5357 7.57819 66.518 6.55994 65.264 6.55994C66.9298 6.55994 68.5958 6.55994 70.2616 6.55994C71.5157 6.55994 72.5333 7.57819 72.5333 8.83275Z"
      fill="#8A8A8A"
    />
    <path
      d="M58.9037 73.8357C58.9037 75.957 58.9037 78.0782 58.9037 80.1995C58.9037 80.6995 58.4948 81.1087 57.9951 81.1087C51.9829 81.1087 45.9708 81.1087 39.9586 81.1087C43.6295 81.0359 55.7235 80.2541 55.7235 72.9264C56.4807 72.9264 57.238 72.9264 57.9952 72.9264C58.4949 72.9266 58.9037 73.3357 58.9037 73.8357Z"
      fill="#8A8A8A"
    />
    <path
      d="M38.005 77.9267C38.005 76.687 38.005 75.4473 38.005 74.2076C38.005 74.0021 38.1713 73.8357 38.3766 73.8357C41.0922 73.8357 43.8079 73.8357 46.5235 73.8357C46.5235 73.8357 40.0495 74.5176 38.005 77.9267Z"
      fill="#E0E0E0"
    />
    <path
      d="M33.5754 74.2902C33.5754 73.0505 33.5754 71.8108 33.5754 70.5711C33.5754 70.3657 33.7417 70.1992 33.947 70.1992C36.6626 70.1992 39.3783 70.1992 42.0939 70.1992C42.0939 70.1992 35.6197 70.881 33.5754 74.2902Z"
      fill="#4E5868"
    />
    <path
      d="M48 49.7436C43.0661 49.7436 29.3819 39.3296 27.7237 14.7421C29.5228 14.7421 31.3218 14.7421 33.1209 14.7421C34.4793 44.8253 48 49.7436 48 49.7436Z"
      fill="#E0E0E0"
    />
    <path
      d="M38.4592 67.4719C38.4592 67.4719 44.8197 63.3809 44.8197 57.4714C44.8197 60.8049 44.8197 64.1384 44.8197 67.4719C42.6995 67.4719 40.5794 67.4719 38.4592 67.4719Z"
      fill="#E0E0E0"
    />
    <path
      d="M26.6469 7.46912C26.6469 7.92368 26.6469 8.37823 26.6469 8.83279C25.8896 8.83279 25.1325 8.83279 24.3752 8.83279C24.3752 8.08271 24.984 7.46912 25.7383 7.46912C26.0412 7.46912 26.344 7.46912 26.6469 7.46912Z"
      fill="#E0E0E0"
    />
    <path
      d="M71.602 12.9238C71.5701 14.1512 71.5111 15.3648 71.4157 16.5603C70.1224 16.5603 68.8291 16.5603 67.5359 16.5603C67.6873 15.3482 67.8388 14.136 67.9902 12.9238C69.1941 12.9238 70.3981 12.9238 71.602 12.9238Z"
      fill="#8A8A8A"
    />
    <path
      d="M63.8511 41.4797C62.9607 42.8479 62.0112 44.0935 61.0117 45.1982C60.309 45.1982 59.6063 45.1982 58.9036 45.1982C59.4398 44.6467 59.9759 44.0951 60.512 43.5436C61.1526 42.8814 61.7931 42.2193 62.4337 41.5572C62.9108 41.5479 63.3833 41.5207 63.8511 41.4797Z"
      fill="#8A8A8A"
    />
  </svg>
);

export const BronzeCupIcon = () => (
  <svg width="96" height="96" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M48.0986 89.4399C63.6498 89.4399 76.2566 89.084 76.2566 88.6449C76.2566 88.2058 63.6498 87.8499 48.0986 87.8499C32.5473 87.8499 19.9405 88.2058 19.9405 88.6449C19.9405 89.084 32.5473 89.4399 48.0986 89.4399Z"
      fill="#D8DFEA"
    />
    <path
      d="M84.8 14.7422C84.8 17.3181 84.8 19.894 84.8 22.4699C84.8 35.0205 74.6276 45.1983 62.084 45.1983C61.0239 45.1983 59.9638 45.1983 58.9036 45.1983C60.0803 43.9846 61.257 42.7708 62.4337 41.5571C72.7968 41.3707 81.1654 32.8795 81.1654 22.4699C81.1654 20.5001 81.1654 18.5304 81.1654 16.5607C76.6222 16.5607 72.079 16.5607 67.5358 16.5607C67.6873 15.3485 67.8387 14.1364 67.9902 12.9242C72.9878 12.9242 77.9853 12.9242 82.9829 12.9242C83.9867 12.9239 84.8 13.7376 84.8 14.7422Z"
      fill="#CD7F32"
    />
    <path
      d="M59.8123 67.0944C59.8123 68.4323 59.8123 69.7703 59.8123 71.1082C51.9375 71.1082 44.0625 71.1082 36.1876 71.1082C36.1876 69.7703 36.1876 68.4323 36.1876 67.0944C36.1876 66.7672 36.3648 66.4625 36.651 66.3035C37.2477 65.9671 37.8444 65.6308 38.4411 65.2944C41.5395 63.549 43.4568 60.2715 43.4568 56.7122C43.4568 55.2985 43.4568 53.8848 43.4568 52.4711C46.4856 52.4711 49.5144 52.4711 52.5432 52.4711C52.5432 53.8848 52.5432 55.2985 52.5432 56.7122C52.5432 60.2714 54.4605 63.5488 57.5589 65.2944C58.1556 65.6308 58.7523 65.9671 59.349 66.3035C59.6352 66.4625 59.8123 66.7672 59.8123 67.0944Z"
      fill="#CD7F32"
    />
    <path
      d="M59.8124 67.0944C59.8124 68.4323 59.8124 69.7703 59.8124 71.1082C59.0552 71.1082 58.298 71.1082 57.5408 71.1082C57.5408 69.7703 57.5408 68.4323 57.5408 67.0944C57.5408 66.7672 57.3637 66.4625 57.0774 66.3035C56.4807 65.9671 55.8841 65.6308 55.2874 65.2944C52.189 63.549 50.2717 60.2715 50.2717 56.7122C50.2717 55.2985 50.2717 53.8848 50.2717 52.4711C51.029 52.4711 51.7861 52.4711 52.5434 52.4711C52.5434 53.8848 52.5434 55.2985 52.5434 56.7122C52.5434 60.2714 54.4607 63.5488 57.5591 65.2944C58.1558 65.6308 58.7525 65.9671 59.3492 66.3035C59.6352 66.4625 59.8124 66.7672 59.8124 67.0944Z"
      fill="#8B5A2B"
    />
    <path
      d="M55.2691 48.9254C55.2691 49.8042 55.2691 50.6831 55.2691 51.5619C55.2691 52.8165 54.2515 53.8347 52.9974 53.8347C49.6657 53.8347 46.3341 53.8347 43.0024 53.8347C41.7485 53.8347 40.7307 52.8165 40.7307 51.5619C40.7307 50.6831 40.7307 49.8042 40.7307 48.9254C45.5768 48.9254 50.423 48.9254 55.2691 48.9254Z"
      fill="#CD7F32"
    />
    <path d="M43.4568 53.8348H52.5432V55.1713H43.4568V53.8348Z" fill="#8B5A2B" />
    <path
      d="M63.4469 70.1992C63.4469 75.5024 63.4469 80.8057 63.4469 86.109C53.1489 86.109 42.851 86.109 32.5531 86.109C32.5531 80.8057 32.5531 75.5024 32.5531 70.1992C32.5531 69.6992 32.9621 69.29 33.4618 69.29C43.1539 69.29 52.8461 69.29 62.5383 69.29C63.0381 69.29 63.4469 69.6992 63.4469 70.1992Z"
      fill="#343B49"
    />
    <path
      d="M63.4469 70.1992C63.4469 75.5024 63.4469 80.8057 63.4469 86.109C62.8411 86.109 62.2354 86.109 61.6296 86.109C61.6296 80.8057 61.6296 75.5024 61.6296 70.1992C61.6296 69.6992 61.2206 69.29 60.7209 69.29C61.3267 69.29 61.9325 69.29 62.5383 69.29C63.0381 69.29 63.4469 69.6992 63.4469 70.1992Z"
      fill="#262D38"
    />
    <path
      d="M66.1728 85.6545C66.1728 86.2606 66.1728 86.8666 66.1728 87.4727C66.1728 87.9727 65.7638 88.3818 65.2641 88.3818C53.7547 88.3818 42.2453 88.3818 30.7359 88.3818C30.2362 88.3818 29.8272 87.9727 29.8272 87.4727C29.8272 86.8666 29.8272 86.2606 29.8272 85.6545C29.8272 85.1545 30.2362 84.7454 30.7359 84.7454C42.2453 84.7454 53.7547 84.7454 65.2641 84.7454C65.764 84.7454 66.1728 85.1545 66.1728 85.6545Z"
      fill="#262D38"
    />
    <path
      d="M66.1728 85.6545C66.1728 86.2606 66.1728 86.8666 66.1728 87.4727C66.1728 87.9727 65.7638 88.3818 65.2641 88.3818C64.6583 88.3818 64.0526 88.3818 63.4468 88.3818C63.9465 88.3818 64.3555 87.9727 64.3555 87.4727C64.3555 86.8666 64.3555 86.2606 64.3555 85.6545C64.3555 85.1545 63.9465 84.7454 63.4468 84.7454C64.0526 84.7454 64.6583 84.7454 65.2641 84.7454C65.7639 84.7454 66.1728 85.1545 66.1728 85.6545Z"
      fill="#171C23"
    />
    <path
      d="M58.9037 73.8357C58.9037 75.9569 58.9037 78.0782 58.9037 80.1995C58.9037 80.6995 58.4948 81.1086 57.9951 81.1086C51.3317 81.1086 44.6684 81.1086 38.005 81.1086C37.5053 81.1086 37.0963 80.6995 37.0963 80.1995C37.0963 78.0782 37.0963 75.9569 37.0963 73.8357C37.0963 73.3357 37.5053 72.9265 38.005 72.9265C44.6684 72.9265 51.3317 72.9265 57.9951 72.9265C58.4949 72.9265 58.9037 73.3357 58.9037 73.8357Z"
      fill="#CD7F32"
    />
    <path
      d="M55.2692 48.9254C55.2692 49.8042 55.2692 50.6831 55.2692 51.5619C55.2692 52.8165 54.2515 53.8347 52.9974 53.8347C52.3917 53.8347 51.7859 53.8347 51.1802 53.8347C52.4341 53.8347 53.4519 52.8165 53.4519 51.5619C53.4519 50.6831 53.4519 49.8042 53.4519 48.9254C54.0577 48.9254 54.6634 48.9254 55.2692 48.9254Z"
      fill="#8B5A2B"
    />
    <path
      d="M38.4592 45.1981C36.9448 45.1981 35.4304 45.1981 33.916 45.1981C21.3723 45.1981 11.2 35.0203 11.2 22.4698C11.2 19.8939 11.2 17.3181 11.2 14.7423C11.2 13.7376 12.0133 12.9241 13.0173 12.9241C18.0148 12.9241 23.0124 12.9241 28.0099 12.9241C28.0099 14.1362 28.0099 15.3483 28.0099 16.5605C23.6181 16.5605 19.2263 16.5605 14.8345 16.5605C14.8345 18.5302 14.8345 20.5 14.8345 22.4698C14.8345 32.8794 23.2032 41.3706 33.5662 41.557C35.1972 42.7707 36.8282 43.9844 38.4592 45.1981Z"
      fill="#CD7F32"
    />
    <path
      d="M70.2618 9.28735C70.2618 9.89343 70.2618 10.4995 70.2618 11.1056C70.2618 33.1974 60.2939 51.1073 48 51.1073C35.7061 51.1073 25.7383 33.1975 25.7383 11.1056C25.7383 10.4995 25.7383 9.89343 25.7383 9.28735C40.5794 9.28735 55.4206 9.28735 70.2618 9.28735Z"
      fill="#CD7F32"
    />
    <path
      d="M25.9427 16.5605C25.337 16.5605 24.7312 16.5605 24.1254 16.5605C24.0346 15.365 23.9755 14.1514 23.9436 12.9241C24.5494 12.9241 25.1552 12.9241 25.7609 12.9241C25.7928 14.1513 25.8518 15.365 25.9427 16.5605Z"
      fill="#8B5A2B"
    />
    <path
      d="M36.3512 45.1981C35.7454 45.1981 35.1397 45.1981 34.5339 45.1981C33.5208 44.0799 32.5576 42.8162 31.6626 41.4252C32.2896 41.5025 32.921 41.5434 33.5662 41.557C34.4386 42.8979 35.3699 44.1162 36.3512 45.1981Z"
      fill="#8B5A2B"
    />
    <path
      d="M55.2691 48.9254C55.2691 49.2285 55.2691 49.5315 55.2691 49.8346C52.9885 51.2483 50.5441 52.0164 48 52.0164C45.4558 52.0164 43.0115 51.2483 40.7308 49.8346C40.7308 49.5315 40.7308 49.2285 40.7308 48.9254C43.0115 50.3392 45.4558 51.1074 48 51.1074C50.5441 51.1074 52.9885 50.3392 55.2691 48.9254Z"
      fill="#8B5A2B"
    />
    <path
      d="M70.2618 9.28735C70.2618 9.89343 70.2618 10.4995 70.2618 11.1056C70.2618 32.5065 60.9072 49.9846 49.145 51.0574C60.5757 49.971 64.8099 32.4975 64.8099 11.1056C64.8099 10.4995 64.8099 9.89343 64.8099 9.28735C66.6272 9.28735 68.4445 9.28735 70.2618 9.28735Z"
      fill="#8B5A2B"
    />
    <path
      d="M72.5333 8.83275C72.5333 9.46011 72.2789 10.0283 71.8699 10.4419C71.4565 10.851 70.8887 11.1056 70.2616 11.1056C55.4205 11.1056 40.5794 11.1056 25.7383 11.1056C24.4843 11.1056 23.4665 10.0873 23.4665 8.83275C23.4665 8.20539 23.7209 7.63721 24.1299 7.22361C24.5433 6.81449 25.1112 6.55994 25.7383 6.55994C40.5794 6.55994 55.4206 6.55994 70.2618 6.55994C71.5157 6.55994 72.5333 7.57819 72.5333 8.83275Z"
      fill="#CD7F32"
    />
    <path
      d="M70.2618 11.1056C70.2618 11.7147 70.2527 12.3193 70.2391 12.9238C55.413 12.9238 40.587 12.9238 25.7609 12.9238C25.7473 12.3192 25.7383 11.7147 25.7383 11.1056C40.5794 11.1056 55.4206 11.1056 70.2618 11.1056Z"
      fill="#8B5A2B"
    />
    <path
      d="M72.5333 8.83275C72.5333 9.46011 72.2789 10.0283 71.8699 10.4419C71.4565 10.851 70.8887 11.1056 70.2616 11.1056C68.5958 11.1056 66.9298 11.1056 65.264 11.1056C65.891 11.1056 66.4589 10.851 66.8723 10.4419C67.2813 10.0283 67.5357 9.45995 67.5357 8.83275C67.5357 7.57819 66.518 6.55994 65.264 6.55994C66.9298 6.55994 68.5958 6.55994 70.2616 6.55994C71.5157 6.55994 72.5333 7.57819 72.5333 8.83275Z"
      fill="#8B5A2B"
    />
    <path
      d="M58.9037 73.8357C58.9037 75.957 58.9037 78.0782 58.9037 80.1995C58.9037 80.6995 58.4948 81.1087 57.9951 81.1087C51.9829 81.1087 45.9708 81.1087 39.9586 81.1087C43.6295 81.0359 55.7235 80.2541 55.7235 72.9264C56.4807 72.9264 57.238 72.9264 57.9952 72.9264C58.4949 72.9266 58.9037 73.3357 58.9037 73.8357Z"
      fill="#8B5A2B"
    />
    <path
      d="M38.005 77.9267C38.005 76.687 38.005 75.4473 38.005 74.2076C38.005 74.0021 38.1713 73.8357 38.3766 73.8357C41.0922 73.8357 43.8079 73.8357 46.5235 73.8357C46.5235 73.8357 40.0495 74.5176 38.005 77.9267Z"
      fill="#E6A561"
    />
    <path
      d="M33.5754 74.2902C33.5754 73.0505 33.5754 71.8108 33.5754 70.5711C33.5754 70.3657 33.7417 70.1992 33.947 70.1992C36.6626 70.1992 39.3783 70.1992 42.0939 70.1992C42.0939 70.1992 35.6197 70.881 33.5754 74.2902Z"
      fill="#4E5868"
    />
    <path
      d="M48 49.7436C43.0661 49.7436 29.3819 39.3296 27.7237 14.7421C29.5228 14.7421 31.3218 14.7421 33.1209 14.7421C34.4793 44.8253 48 49.7436 48 49.7436Z"
      fill="#E6A561"
    />
    <path
      d="M38.4592 67.4719C38.4592 67.4719 44.8197 63.3809 44.8197 57.4714C44.8197 60.8049 44.8197 64.1384 44.8197 67.4719C42.6995 67.4719 40.5794 67.4719 38.4592 67.4719Z"
      fill="#E6A561"
    />
    <path
      d="M26.6469 7.46912C26.6469 7.92368 26.6469 8.37823 26.6469 8.83279C25.8896 8.83279 25.1325 8.83279 24.3752 8.83279C24.3752 8.08271 24.984 7.46912 25.7383 7.46912C26.0412 7.46912 26.344 7.46912 26.6469 7.46912Z"
      fill="#E6A561"
    />
    <path
      d="M71.602 12.9238C71.5701 14.1512 71.5111 15.3648 71.4157 16.5603C70.1224 16.5603 68.8291 16.5603 67.5359 16.5603C67.6873 15.3482 67.8388 14.136 67.9902 12.9238C69.1941 12.9238 70.3981 12.9238 71.602 12.9238Z"
      fill="#8B5A2B"
    />
    <path
      d="M63.8511 41.4797C62.9607 42.8479 62.0112 44.0935 61.0117 45.1982C60.309 45.1982 59.6063 45.1982 58.9036 45.1982C59.4398 44.6467 59.9759 44.0951 60.512 43.5436C61.1526 42.8814 61.7931 42.2193 62.4337 41.5572C62.9108 41.5479 63.3833 41.5207 63.8511 41.4797Z"
      fill="#8B5A2B"
    />
  </svg>
);

export const MedalIcon = () => (
  <svg width="96" height="96" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_252_107)">
      <path
        d="M94.9088 1.81657C94.3247 0.699798 93.1685 0 91.9085 0H64.7622C63.6522 0 62.613 0.543677 61.9805 1.45552L35.8442 39.1111H30.2297C30.4278 38.6806 30.6625 38.2623 30.9388 37.8634L45.1145 17.44L34.0199 1.45552C33.3873 0.543677 32.3478 0 31.2382 0H4.09148C2.83152 0 1.67532 0.699798 1.09124 1.81657C0.506837 2.93301 0.591201 4.28186 1.31007 5.31717L24.9406 39.3626C23.7046 39.8675 22.8328 41.0799 22.8328 42.4973C22.8328 44.3672 24.3488 45.8835 26.219 45.8835H30.2513C35.2433 42.2646 41.3763 40.1267 48 40.1267C54.6237 40.1267 60.7567 42.2642 65.7487 45.8835H69.7813C71.6512 45.8835 73.1675 44.3675 73.1675 42.4973C73.1675 41.0799 72.2961 39.8672 71.0597 39.3626L94.6903 5.31717C95.4088 4.28186 95.4932 2.93301 94.9088 1.81657Z"
        fill="#039BE5"
      />
      <path
        d="M48 58.8357C41.6049 58.8357 36.4021 64.0388 36.4021 70.4336C36.4021 76.8288 41.6049 82.0318 48 82.0318C54.3952 82.0318 59.5979 76.8288 59.5979 70.4336C59.5979 64.0388 54.3952 58.8357 48 58.8357Z"
        fill="#FFD700"
      />
      <path
        d="M48 44.8679C33.9029 44.8679 22.4339 56.3365 22.4339 70.4339C22.4339 84.5314 33.9029 96 48 96C62.0971 96 73.5664 84.5311 73.5664 70.4336C73.5664 56.3362 62.0971 44.8679 48 44.8679ZM48 86.7724C38.9909 86.7724 31.6613 79.4431 31.6613 70.4336C31.6613 61.4245 38.9909 54.0952 48 54.0952C57.0091 54.0952 64.3388 61.4245 64.3388 70.4336C64.3388 79.4431 57.0091 86.7724 48 86.7724Z"
        fill="#FFD700"
      />
    </g>
    <defs>
      <clipPath id="clip0_252_107">
        <rect width="96" height="96" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
